import { Injector } from "@angular/core";
import { FieldDefinition } from "../../../../../sections/webtrader/webtrader/message/fieldDefinition";
import { Art57Node } from "../../Art57Node/Art57Node";
import { Acknoledgment } from "../../../Data/WebTraderData/Acknowledgment";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";

export class TreeNodeAcknowledgment extends Art57Node {

    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new Acknoledgment(new FieldDefinition(injector)),
              '{param1}-{param2}-{param3}-{param4}'
      );
  
      this.parent = parent;
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      let param1 = this.ioc!.get(LookupGetService).retrieveValueFromCache('reportname', this.data.model.reportname);
      let param2 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype' , this.data.model.operationtype);
      let param3 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationresult' , this.data.model.operationresult);
      if ((param3===null)||(param3==='')){
        param3 = this.data.model.operationresultdesc;
      }
      let param4 = this.data.model.evCode? this.data.model.evCode : '';
      this.label = this.labelTemplate
                                      .replace('{param1}',param1)
                                      .replace('{param2}',param2)
                                      .replace('{param3}',param3)
                                      .replace('{param4}',param4);
    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.reportname
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'reportname',
          this.data.model.reportname
          ) : '-',
        this.data.model.localnumber,
        this.data.model.evCode? this.data.model.evCode:'',
        this.data.model && this.data.model.operationtype
         ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        ) : '-',
         this.data.model && this.data.model.operationresult
         ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationresult',
           this.data.model.operationresult) : '-',
        this.data.model.operationresultdesc
      ];
    }
  
  }
  